import { PalletBalance, PalletType } from 'interfaces';

export const getPalletsAmountLabel = (palletType: PalletType, palletBalance: PalletBalance) => {
   const palletsAmount = palletBalance[palletType];
   return palletsAmount !== undefined ? palletsAmount : '-';
};
